import { render, staticRenderFns } from "./HistoryLearningResult.vue?vue&type=template&id=0f510eef&scoped=true&lang=pug&"
import script from "./HistoryLearningResult.vue?vue&type=script&lang=ts&"
export * from "./HistoryLearningResult.vue?vue&type=script&lang=ts&"
import style0 from "./HistoryLearningResult.vue?vue&type=style&index=0&id=0f510eef&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f510eef",
  null
  
)

export default component.exports